import './Modal.scss';
import { Modal, Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';

export default function CompModal({ open, onClose, title, children}) {
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <div className="modal-container">
                {/* <div className="modal-header ">
                    {title}
                </div> */}
                
                <Button type="button" aria-label="Close" className="modal-close" onClick={onClose}>
                    <CloseIcon />
                </Button>
                <div className="modal-body" style={{"overflow": "hidden"}}>
                    {children}
                </div>
            </div>
        </Modal>
    )
}
